export default __webpack_public_path__ + "static/media/logo.6780d143.png";